export interface Implicit<T> {
	$implicit: T;
	close?: () => void;
}

export function asImplicit<T>(data: T): Implicit<T> {
	return {
		$implicit: data,
	};
}
